import { Backdrop, CircularProgress } from '@mui/material';
import { useLoadingStore } from '../../store/loadingStore';
import { useAuth0 } from '@auth0/auth0-react';

export const LoadingIndicator = () => {
  const isLoadingIndicator = useLoadingStore((state) => state.isLoadingIndicator);
  const { isLoading: isLoadingAuth } = useAuth0();

  return (
    <Backdrop
      sx={{
        color: '#fff',
        zIndex: (theme) => theme.zIndex.drawer + 1,
      }}
      open={isLoadingIndicator || isLoadingAuth}
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}; 